import { render, staticRenderFns } from "./discountApprovalManage.vue?vue&type=template&id=04ed3b13&scoped=true&"
import script from "./discountApprovalManage.vue?vue&type=script&lang=js&"
export * from "./discountApprovalManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed3b13",
  null
  
)

export default component.exports